import React from 'react';
import { Typography } from "../Typography";
import { Button } from "../Button";
import styles from "./PaginationControl.module.scss";
export function PaginationControl(props) {
  const {
    pageSize,
    pageNumber,
    total,
    testid = 'pagination-controls',
    onPageNumberChange
  } = props;
  const start = (pageNumber - 1) * pageSize + 1;
  const end = Math.min(pageNumber * pageSize, total);
  const isPreviousDisabled = pageNumber === 1;
  const isNextDisabled = pageNumber === Math.ceil(total / pageSize);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary",
    "data-testid": "".concat(testid, "-label")
  }, "Viewing ", start, "-", end, " of ", total), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    skin: "primaryOutline",
    disabled: isPreviousDisabled,
    "data-testid": "".concat(testid, "-previous"),
    onClick: () => onPageNumberChange(pageNumber - 1)
  }, "Previous"), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    skin: "primaryOutline",
    disabled: isNextDisabled,
    "data-testid": "".concat(testid, "-next"),
    onClick: () => onPageNumberChange(pageNumber + 1)
  }, "Next"));
}